import { FC, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { getPartnerConfig, getPartnerProvider } from 'partners/shared/partnerRegistry';

import useBranding from 'store/branding';

import Landing from './Landing';

const Auth: FC = () => {
  const [brandingState] = useBranding();
  const { settings } = brandingState;

  const isDefaultLanding = settings?.meta?.isDefaultLanding ?? true;
  const shouldUsePartnerRouting = !isDefaultLanding && settings?.id;

  //const isLoadingBranding = (!settings?.id && status === 'loading') || status === 'idle';
  // if (isLoadingBranding) {
  //   return <ProjectLoading />;
  // }

  if (!shouldUsePartnerRouting) {
    return <Landing />;
  }

  const partnerConfig = getPartnerConfig(settings.id);
  const PartnerProvider = getPartnerProvider(settings.id);

  if (!partnerConfig || !PartnerProvider) {
    return <Landing />;
  }

  return (
    <PartnerProvider>
      <Suspense fallback={null}>
        <Routes>
          {partnerConfig.routes.map((route) => {
            const Component = route.component;
            return <Route key={route.path} path={route.path} element={<Component />} />;
          })}
          {partnerConfig.routes[0] &&
            ((): JSX.Element => {
              const FallbackComponent = partnerConfig.routes[0].component;
              return <Route path="*" element={<FallbackComponent />} />;
            })()}
        </Routes>
      </Suspense>
    </PartnerProvider>
  );
};

export default Auth;
